import React from 'react'

import ForgotPassword from '@components/ForgotPassword'
import PasswordRecovery from '@components/PasswordRecovery'

import V2Layout from '../V2Layout'

// Esqueci a senha / redefinição no chrome V2 — os componentes V1 são reusados POR
// INTEIRO (mesmas chamadas users/password/*, mesmos critérios de senha) com o skin
// `.v2-pwd`; as pontes por pathname dentro deles trocam só os destinos de
// navegação e pedem à API o link do e-mail apontando para /v2 (origin=v2).

export function V2ForgotPassword() {
  return (
    <V2Layout>
      <div className="v2-pwd" id="v2-pwd-forgot">
        <ForgotPassword />
      </div>
    </V2Layout>
  )
}

export function V2PasswordRecovery() {
  return (
    <V2Layout>
      <div className="v2-pwd" id="v2-pwd-recovery">
        <PasswordRecovery />
      </div>
    </V2Layout>
  )
}
